module.exports = __webpack_public_path__ + "static/media/bckg4.32b811ef.png";